import * as THREE from 'three';
import { toCreasedNormals } from 'three/addons/utils/BufferGeometryUtils.js';

// Creased normals (MODELING.md: hard-surface + fractured geo wants creases, not the all-smooth blob).
// Faces meeting sharper than `deg` keep a hard edge; flatter joins stay smooth -- chipped stone instead
// of an inflated balloon. Wraps three's toCreasedNormals; non-indexed input keeps every other attribute
// (vertex colours included), indexed input comes back non-indexed.

export function creasedNormals(geo: THREE.BufferGeometry, deg = 38): THREE.BufferGeometry {
  return toCreasedNormals(geo, (deg * Math.PI) / 180);
}
